import { Dispatch } from 'react';
import { DealerHomepageOptions } from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';

export const DealerLoginPageEventHandlers = (
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    setDealerHomepageOptions: (value: DealerHomepageOptions) => {
      dispatch({
        type: 'set-dealer-home-page-options',
        dealerHomepageOptions: value
      });
    },
    setDealerUsername: (dealerUsername: string) => {
      dispatch({
        type: 'set-dealer-username',
        dealerUsername
      });
    },
    setDealerRepresentative: (dealerRepresentative: string) => {
      dispatch({
        type: 'set-dealer-representative',
        dealerRepresentative
      });
    }
  };
};
